export default {"src":"/_next/static/media/Save-white.91e733f8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};